/**
 * @file
 *
 * 页面曝光监控
 */
import { checkImageVisible } from './image-lazy'

/**
 * @type {object} window
 */
const w = window

let e

let uuid = 0

class Show {
  constructor() {
    this.els = []
    this.scrolls = []
    this.callbacks = {}
  }

  init() {
    this.scrolls.push(w)
    this.scrollInit(this.scrolls[0])
  }

  scrollCallback() {
    for (let i = 0; i < this.els.length; i++) {
      const el = this.els[i]
      const show = checkImageVisible(el)
      if (show) {
        const Uuid = el.dataset.callbackId
        const callback = this.callbacks[Uuid]
        callback && callback.apply(null)
        this.callbacks[Uuid] = null
        this.els.splice(i, 1)
        i--
      }
    }
  }

  scrollInit(el) {
    el.addEventListener('scroll', this.scrollCallback.bind(this))
  }

  addScroll(el) {
    this.scrolls.push(el)
    this.scrollInit(el)
  }

  removeElement(el) {
    const index = this.els.findIndex((val) => val === el)
    if (index !== -1) {
      const callbackId = this.els[index].dataset.callbackId
      if (callbackId) {
        this.callbacks[callbackId] = null
      }
      this.els.splice(index, 1)
    }
  }

  removeScroll(el) {
    const index = this.scrolls.findIndex((val) => val === el)
    if (index !== -1) {
      this.scrolls[index].removeEventListener('scroll', this.scrollCallback)
      this.scrolls.splice(index, 1)
    }
  }

  // eslint-disable-next-line consistent-return
  addElement(el, callback) {
    const isShow = checkImageVisible(el)
    if (isShow) {
      return callback()
    }
    this.els.push(el)
    el.dataset.callbackId = ++uuid
    this.callbacks[uuid] = callback
  }
}

export function Interface() {
  if (!e) {
    e = new Show()
    e.init()
  }
  return {
    addScroll: e.addScroll.bind(e),
    removeScroll: e.removeScroll.bind(e),
    addElement: e.addElement.bind(e),
    removeElement: e.removeElement.bind(e),
  }
}

export default {
  Show,
}
